import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { DEFAULT_PAGE_SIZE, TableConfig } from "../../configs/constants";
import { ApplicationStatusSearchRequest } from "../api-interfaces";
import { getToday } from "../../utils/date";
import { formatDate } from "../../utils/format";

interface ApplicationStatusList {
  searchCriteria: ApplicationStatusSearchRequest;
  tableConfig: TableConfig;
}

export const INITIAL_SEARCH_CRITERIA: ApplicationStatusSearchRequest = {
  serviceCode: "",
  contractRoute: "",
  cpid: "",
  contractType: "",
  applicationNo: "",
  startDate: formatDate(getToday(-180)),
  endDate: formatDate(getToday()),
  fixedTimeStart: " ",
  fixedTimeEnd: " ",
  companyName: "",
  merchantName: "",
  particularRateFlag: "",
  merchantAnswered: "",
  applicationTypes: [],
  applicationStatuses: [],
  applicationDetailStatuses: [],
  timestamp: -1,
  applicantUserType: [],
  applicantEmail: "",
  applicationFormTypeCodes: [],
};

const initialState: ApplicationStatusList = {
  searchCriteria: INITIAL_SEARCH_CRITERIA,
  tableConfig: {
    pageSize: DEFAULT_PAGE_SIZE,
    pageIndex: 1,
    columnWidths: [],
  },
};

const applicationStatusListSlice = createSlice({
  name: "applicationStatusList",
  initialState,
  reducers: {
    setSearchCriteria: (
      state,
      action: PayloadAction<ApplicationStatusSearchRequest>
    ) => {
      state.searchCriteria = action.payload;
      state.tableConfig = {
        pageSize: DEFAULT_PAGE_SIZE,
        pageIndex: 1,
        columnWidths: [],
      };
    },
    setPageIndex: (state, action: PayloadAction<number>) => {
      state.tableConfig.pageIndex = action.payload;
    },
    setColumnWidths: (state, action: PayloadAction<number[]>) => {
      state.tableConfig.columnWidths = action.payload;
    },
    changePageSize: (state, action: PayloadAction<number>) => {
      state.tableConfig.pageSize = action.payload;
      state.tableConfig.pageIndex = 1;
    },
  },
});

export const {
  setSearchCriteria,
  setPageIndex,
  setColumnWidths,
  changePageSize,
} = applicationStatusListSlice.actions;

export default applicationStatusListSlice.reducer;
